// Sidebar_Community.tsx
import Sidebar, { PageItem } from "./sidebar";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import MapIcon from "@mui/icons-material/Map"; 

const pages: PageItem[] = [
  { name: "Communities", link: "/community/", icon: <PeopleIcon /> },
  { name: "People", link: "/community/people/", icon: <PersonIcon /> },
  { name: "Map", link: "/community/map/", icon: <MapIcon /> },
  { name: "Addresses", link: "/community/addresses/", icon: <HomeWorkIcon /> },
  { name: "Discipleship Pathway", link: "/community/discipleship-pathway/", icon: <AccountTreeIcon /> },
];

export default function Sidebar_Community() {
  return <Sidebar pages={pages} primaryColorKey="communityPrimary" />;
}
